import { StatementInterface } from "./statement_interface";
import { wrapErrorHandler } from "../../utils/wrap_error_handler";
import http from "../../http";
import { Statement } from "../../../../domain/entities/statement";
import { Order } from "../../../../domain/entities/order";
import { ListResponse } from "../../../../domain/entities/shop/product/listResponse";

class StatementRepository implements StatementInterface {
  async list(order: Order): Promise<ListResponse<Statement[]>> {
    return wrapErrorHandler<ListResponse<Statement[]>>(async () => {
      const response = await http.get("/api/decola/list/statement/user", {
        params: {
          page: order.page,
          limit: 20,
          orderBy: order.orderBy,
          ordinationAsc: order.isAsc,
          firstDate: order.firstDate,
          lastDate: order.lastDate,
          type: order.type,
          typeCode: order.typeCode,
        }
      });
      return response.data;
    });
  }
}

export default new StatementRepository() as StatementInterface;
